"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewHelpers = void 0;
var _utils = require("./utils");
var _react = require("react");
var _viewHelpersMap = {
  date: {
    startOfView: _utils.startOfMonth,
    endOfView: _utils.endOfMonth,
    nextView: _utils.getNextMonth,
    previousView: _utils.getPreviousMonth,
    isSameView: _utils.isSameMonth,
    startOfItem: _utils.startOfDay,
    endOfItem: _utils.endOfDay,
    isSameItem: _utils.isSameDay,
    nextItem: _utils.getNextDay,
    previousItem: _utils.getPreviousDay,
    today: _utils.getToday
  },
  month: {
    startOfView: _utils.startOfYear,
    endOfView: _utils.endOfYear,
    nextView: _utils.getNextYear,
    previousView: _utils.getPreviousYear,
    isSameView: _utils.isSameYear,
    startOfItem: _utils.startOfMonth,
    endOfItem: _utils.endOfMonth,
    isSameItem: _utils.isSameMonth,
    nextItem: _utils.getNextMonth,
    previousItem: _utils.getPreviousMonth
  }
};
var useViewHelpers = exports.useViewHelpers = function useViewHelpers(view) {
  return (0, _react.useMemo)(function () {
    return _viewHelpersMap[view];
  }, [view]);
};